import { AddPlusSquare, LegalScale, MusicSongFavouriteLike, Shape, ThumbsUp, ChartPlusAdd, Warning } from 'assets/icons'

export const ICONMAP = {
  shape: Shape,
  warning: Warning,
  'add-plus-square': AddPlusSquare,
  'legal-scale': LegalScale,
  'thumbs-up': ThumbsUp,
  'music-song-favourite-like': MusicSongFavouriteLike,
  'chart-plus-add': ChartPlusAdd,
} as Record<string, (props: React.SVGProps<SVGSVGElement>) => JSX.Element>
